module.exports = __webpack_public_path__ + "img/img8.1e532293.png";